import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { logoutUser } from '../../store/actions/shared/Shared';

class Footer extends Component {
  render() {
    const { auth } = this.props;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="myBanner" style={{ padding: '56px 0 20px 0' }}>
            <div className="container">
              <div className="row">
                <div
                  className="col-12 col-md-4 col-xs-12 col-sm-12 mb-5 footer-categorie"
                  style={{ paddingLeft: '40px' }}
                >
                  <p style={{ textAlign: 'left' }}>
                    <img
                      src="https://www.grospick.com/img/white-logo.png"
                      style={{ width: '150px' }}
                      alt=""
                    />
                  </p>
                  <p
                    className="text-white footer-paragraph"
                    style={{
                      color: '#fff',
                      textAlign: 'left',
                      fontSize: '13px',
                      paddingBottom: '0px',
                      marginBottom: '2px',
                      fontWeight: 400
                    }}
                  >
                    A delivery company with a personal touch offering a huge
                    range of services and locations convenient to you.
                  </p>
                  <br />
                  <p
                    className="text-white footer-paragraph"
                    style={{
                      color: '#fff',
                      textAlign: 'left',
                      fontSize: '13px',
                      paddingBottom: '0px',
                      marginBottom: '2px',
                      fontWeight: 400
                    }}
                  >
                    We deliver anything from bread to fruits or even groceries,
                    door to door and on-demand.
                  </p>
                  <br />

                  <div class="social-icons">
                    <a
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/Grospick-108163027510472/"
                      class="social-icon social-icon--facebook"
                    >
                      <i class="fa fa-facebook"></i>
                      <div class="tooltip">Facebook</div>
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://twitter.com/grospick"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      class="social-icon social-icon--twitter"
                    >
                      <i class="fa fa-twitter"></i>
                      <div class="tooltip">Twitter</div>
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      href="https://www.instagram.com/grospicker/?hl=en"
                      class="social-icon social-icon--codepen"
                    >
                      <i class="fa fa-instagram"></i>
                      <div class="tooltip">Instagram</div>
                    </a>
                    <a
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      class="social-icon social-icon--github"
                      href="//#endregion"
                    >
                      <i class="fa fa-linkedin"></i>
                      <div class="tooltip">LinkedIn</div>
                    </a>
                    <a
                      class="social-icon social-icon--dribbble"
                      style={{ color: '#212529' }}
                      href="//#endregion"
                    >
                      <i class="fa fa-envelope-o"></i>
                      <div class="tooltip">Mail</div>
                    </a>
                  </div>
                </div>
                <div className="col-4 col-md-3" style={{ textAlign: 'left' }}>
                  <h5
                    className="text-white footer-font"
                    style={{ paddingBottom: '3px', fontWeight: '700' }}
                  >
                    GROSPICK
                  </h5>
                  <Link to="/about" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        paddingTop: '2px',
                        marginBottom: '4px',
                        fontWeight: 400
                      }}
                    >
                      About Us
                    </p>
                  </Link>
                  <Link to="/jobs" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Jobs
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Grospick for Patners
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Grospick for Business
                    </p>
                  </Link>
                  <Link to="/contact" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Contact Us
                    </p>
                  </Link>
                  <Link to="/termsConditions" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Terms & Conditions
                    </p>
                  </Link>
                  <Link to="/policy" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        fontWeight: 400
                      }}
                    >
                      Privacy Policy
                    </p>
                  </Link>
                </div>
                <div className="col-4 col-md-3" style={{ textAlign: 'left' }}>
                  <h5
                    className="text-white footer-font"
                    style={{ paddingBottom: '3px', fontWeight: '700' }}
                  >
                    CUSTOMERS
                  </h5>
                  {!auth ? (
                    <>
                      <Link
                        to="/vendor/login"
                        style={{ textDecoration: 'none' }}
                      >
                        <p
                          className="text-white footer-paragraph"
                          style={{
                            color: '#fff',
                            fontSize: '15px',
                            paddingBottom: '0px',
                            paddingTop: '2px',
                            marginBottom: '4px',
                            fontWeight: 400
                          }}
                        >
                          Vendor Login
                        </p>
                      </Link>
                      <Link
                        to="/driver/login"
                        style={{ textDecoration: 'none' }}
                      >
                        <p
                          className="text-white footer-paragraph"
                          style={{
                            color: '#fff',
                            fontSize: '15px',
                            paddingBottom: '0px',
                            paddingTop: '2px',
                            marginBottom: '4px',
                            fontWeight: 400
                          }}
                        >
                          Driver Login
                        </p>
                      </Link>
                      <Link
                        to="/admin/login"
                        style={{ textDecoration: 'none' }}
                      >
                        <p
                          className="text-white footer-paragraph"
                          style={{
                            color: '#fff',
                            fontSize: '15px',
                            paddingBottom: '0px',
                            marginBottom: '2px',
                            fontWeight: 400
                          }}
                        >
                          Admin Login
                        </p>
                      </Link>
                      <Link to="/contact" style={{ textDecoration: 'none' }}>
                        <p
                          className="text-white footer-paragraph"
                          style={{
                            color: '#fff',
                            fontSize: '15px',
                            paddingBottom: '0px',
                            marginBottom: '2px',
                            fontWeight: 400
                          }}
                        >
                          Community service
                        </p>
                      </Link>
                    </>
                  ) : (
                    <Link to="/contact" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Community service
                      </p>
                    </Link>
                  )}
                </div>
                <div
                  className="col-4 col-md-2 footer-categorie2"
                  style={{
                    textAlign: 'left',
                    paddingRight: '0px',
                    paddingLeft: '0px'
                  }}
                >
                  <h5
                    className="text-white footer-font"
                    style={{ paddingBottom: '3px', fontWeight: '700' }}
                  >
                    GET OUR APP
                  </h5>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        paddingTop: '2px',
                        marginBottom: '4px',
                        fontWeight: 400
                      }}
                    >
                      <i
                        className="fa fa-android"
                        style={{ paddingRight: '3px' }}
                      ></i>{' '}
                      Android
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      <i
                        className="fa fa-apple"
                        style={{ paddingRight: '3px' }}
                      ></i>{' '}
                      Ios
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      <i
                        className="fa fa-desktop"
                        style={{ paddingRight: '4px' }}
                      ></i>{' '}
                      Desktop
                    </p>
                  </Link>
                </div>
              </div>
              <hr />
              <p style={{ color: '#fff' }}>© Grospick 2021</p>
            </div>
          </div>
        </div>

        {/* <img src='./img/about.jpg'alt='footer'/> */}
      </div>
    );
  }
}
const mapStateWithProps = (state) => ({
  auth: state.user.auth
});
const mapDispatchToProps = (dispatch) => ({
  logoutUser: () => dispatch(logoutUser())
});

export default connect(
  mapStateWithProps,
  mapDispatchToProps
)(withRouter(Footer));
